import React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import TextCard from "../../../TextCard";
import { IHorizontalCardsPanelVariants, ITextCard } from "../../../../types/common";
import { IContentfulRichTextResponse } from "../../../../types/IContentfulRichText";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import GreenLargeIconMobile from "../images/green-large-icon-mobile.svg";
import PurpleLargeIconMobile from "../images/purple-large-icon-mobile.svg";
import YellowLargeIconMobile from "../images/yellow-large-icon-mobile.svg";
import GreenLargeIconDesktop from "../images/green-large-icon-desktop.svg";
import PurpleLargeIconDesktop from "../images/purple-large-icon-desktop.svg";
import YellowLargeIconDesktop from "../images/yellow-large-icon-desktop.svg";

import "./style.scss";

interface IHorizontalCardsPanelV1Props {
  title: IContentfulRichTextResponse;
  subtitle?: string;
  variant: IHorizontalCardsPanelVariants;
  cards: ITextCard[];
}

export const HorizontalCardsPanelV2 = ({
  title, subtitle, variant, cards,
}: IHorizontalCardsPanelV1Props) => {
  const isMobile = useIsMobile();

  let imageVariant: string;

  if (isMobile) {
    switch (variant) {
      case "green": {
        imageVariant = GreenLargeIconMobile;
        break;
      }
      case "purple": {
        imageVariant = PurpleLargeIconMobile;
        break;
      }
      case "yellow":
      default: {
        imageVariant = YellowLargeIconMobile;
        break;
      }
    }
  } else {
    switch (variant) {
      case "green": {
        imageVariant = GreenLargeIconDesktop;
        break;
      }
      case "purple": {
        imageVariant = PurpleLargeIconDesktop;
        break;
      }
      case "yellow":
      default: {
        imageVariant = YellowLargeIconDesktop;
        break;
      }
    }
  }

  return (
    <div className="horizontal-cards-panel--v2">
      <div className="horizontal-cards-panel--v2__content">
        <div className="horizontal-cards-panel--v2__title">
          {title ? renderRichText(title) : null}
        </div>
        <div className="horizontal-cards-panel--v2__body">
          {subtitle && <p className="horizontal-cards-panel--v2__subtitle">{subtitle}</p>}
          <div className="horizontal-cards-panel--v2__cards">
            {cards.map((card, index) => (<TextCard key={`${card.title}-${index}`} card={card} className="horizontal-cards-panel--v2__card" />))}
          </div>
        </div>
      </div>
      <img
        src={imageVariant}
        alt="Icon shaped"
        className={isMobile ? "horizontal-cards-panel--v2__image--mobile" : "horizontal-cards-panel--v2__image--desktop"}
      />
    </div>
  );
};
